import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";
import { serialize } from "../../../helpers/helpers";


const list = async (params) => {
	return apiRequest(
                        "/road-situations/list?" + serialize(params),
                        {
                            'method': "GET"
                        },
                        'ptp_core'
                    );
}


const add = async ( params ) => {
    let add_response = await apiRequest(
                                        "/road-situations/add?" + serialize(params),
                                        {
                                            'method': "POST",
                                            'body': params
                                        },
                                        'ptp_core'
                                    );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const update = async ( params ) => {
    let add_response = await apiRequest(
                                        "/road-situations/update?" + serialize(params),
                                        {
                                            'method': "PUT",
                                            'body': params
                                        },
                                        'ptp_core'
                                    );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const remove = async ( id = 0 ) => {
    let remove_response = await apiRequest(
                                            "/road-situations/delete/" + id,
                                            {
                                                'method': "DELETE"
                                            },
                                            'ptp_core'
                                        );
    if ( typeof(remove_response.id) !== 'undefined' && remove_response.id )
        return remove_response.id;
    else
        return 0;
}


const getImageUrl = ( image_path = '' ) => {
    if ( String(image_path).trim() === '' || image_path.indexOf('http') === 0 )
        return image_path;
    return getSluiceUrl('ptp_core') + "/road-situations/files/" + image_path;
}

const RoadSituationPosts = {
    list,
    add,
    update,
    remove,
    getImageUrl
};

export default RoadSituationPosts;